/**
 * streakDays — hvilke dager i ukestripen som hører til den aktive streaken
 * (#154, steg 4b: ukestripen på Oppgaver).
 *
 * `GET /api/streaks/:id` gir bare lengden (`current_streak`) og siste dag med
 * aktivitet (`last_activity_date`, Oslo-dato `yyyy-mm-dd`). Streaken er da de
 * `current_streak` dagene som ender på den datoen. En dag som ble reddet av en
 * frysning, telles med, fordi den holder streaken i live.
 *
 * Sammenligningen går på kalenderdato (år, måned, dag), ikke på klokkeslett,
 * så sommertid ikke flytter en dag.
 */
import type { StreakRow } from './useStreakQueries';

function dayNumber(y: number, m: number, d: number): number {
  return Math.floor(Date.UTC(y, m - 1, d) / 86_400_000);
}

/** Lager en sjekk for WeekStrip `isDone`. Uten aktiv streak er ingen dag fullført. */
export function streakDayCheck(
  streak: Pick<StreakRow, 'current_streak' | 'last_activity_date'> | undefined,
): (day: Date) => boolean {
  const length = streak?.current_streak ?? 0;
  const [y, m, d] = (streak?.last_activity_date ?? '').slice(0, 10).split('-').map(Number);
  if (length <= 0 || !y || !m || !d) return () => false;
  const last = dayNumber(y, m, d);
  const first = last - (length - 1);
  return (day) => {
    const n = dayNumber(day.getFullYear(), day.getMonth() + 1, day.getDate());
    return n >= first && n <= last;
  };
}
